import { Component, ChangeDetectionStrategy } from '@angular/core';
import { JkBaseComponent, jkLib, LoginService } from 'jk-service';

@Component({
  selector: 'app-audio-recorder',
  templateUrl: './audio-recorder.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./audio-recorder.component.css']
})
export class AudioRecorderComponent extends JkBaseComponent {
  private mediaRecorder: any;
  private audioChunks: any[] = [];
  private audioBlob: Blob | null = null;
  public recordingTime: number = 0;
  private recordingInterval: any;

  startRecording() {
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then(stream => {
        this.mediaRecorder = new MediaRecorder(stream);
        this.mediaRecorder.start();
        this.audioChunks = [];

        this.mediaRecorder.addEventListener('dataavailable', (event: any) => {
          this.audioChunks.push(event.data);
        });

        this.mediaRecorder.addEventListener('stop', () => {
          this.audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
          localStorage.setItem('audioBlob', URL.createObjectURL(this.audioBlob));
          this.recordingTime = (Date.now() - this.recordingTime) / 1000;
        });

        this.recordingTime = Date.now();
        this.recordingInterval = setInterval(() => {
          this.recordingTime = (Date.now() - this.recordingTime) / 1000;
        }, 1000);
      });
  }

  stopRecording() {
    if (this.mediaRecorder) {
      this.mediaRecorder.stop();
      clearInterval(this.recordingInterval);
    }
  }

  discardRecording() {
    this.stopRecording();
    localStorage.removeItem('audioBlob');
    this.recordingTime = 0;
  }

  playRecording() {
    const audioUrl = localStorage.getItem('audioBlob');
    if (audioUrl) {
      const audio = new Audio(audioUrl);
      audio.play();
    }
  }

  async saveRecording() {
    // Implement save functionality if needed
    let fn = jkLib.nowDate()+jkLib.nowTime9()+ '.mp3';
    let body = { fileName:fn, data: this.audioBlob };

    const config = jkLib.axiosConfigInit(
      this.login.host,
      '/uty/saveBase64Audio',
      'post',
      [],
      body
    );
    let ret = jkLib.jkRet;
    let bool = await jkLib.doAxios(config, ret);
    if (!ret.result) {
      this.doShowJson(ret.obj);
    } else {
    };

  }
}
